/* Vintedoisk 01/11 — zoom profissional das fotos do produto (pedido do Rodrigo: "o zoom não é intuitivo").
   Antes: janela do tema com a foto do tamanho da tela e miniaturas, sem dar para ampliar de verdade.
   Agora: PhotoSwipe 5 (já vem no tema, carregado só no 1º toque) em tela cheia com fundo branco —
   arrasta para o lado entre as fotos (só as da cor escolhida), toque/pinça amplia até o tamanho real da foto
   (catálogo ~800–1024 px — zoom além disso só borraria), contador "2 / 5", X para fechar; no computador o clique amplia no ponto clicado.
   Troca o open() do zoom-dialog do tema; o zoom antigo continua como reserva (vídeo ou falha). */
(function () {
  if (!window.photoswipeUrls) return;
  var carregando = null, dicaVista = false;
  try { dicaVista = localStorage.getItem('vk_zoom_dica') === '1'; } catch (e) {}

  function carregar() {
    if (carregando) return carregando;
    var css = document.createElement('link');
    css.rel = 'stylesheet'; css.href = window.photoswipeUrls.css;
    document.head.appendChild(css);
    var estilo = document.createElement('style');
    estilo.textContent =
      '.pswp{--pswp-bg:#fff;--pswp-placeholder-bg:#f5f4f2;--pswp-icon-color:#111;--pswp-icon-color-secondary:#fff;--pswp-icon-stroke-color:#fff;--pswp-icon-stroke-width:0;--pswp-root-z-index:100000}' +
      '.pswp__counter{color:#111;font-size:14px;letter-spacing:.06em;opacity:.8;text-shadow:none}' +
      '.pswp__button--arrow{background:none}.pswp__button--arrow .pswp__icn{background:rgba(255,255,255,.85);border-radius:50%}' +
      '.vk-zoom-dica{position:fixed;left:50%;bottom:calc(24px + env(safe-area-inset-bottom));transform:translateX(-50%);z-index:100001;' +
      'padding:10px 16px;background:rgba(17,17,17,.88);color:#fff;font-size:13px;line-height:1.3;border-radius:2px;white-space:nowrap;pointer-events:none;transition:opacity .4s}';
    document.head.appendChild(estilo);
    // sem import() aqui: a compressão de JS da Shopify troca import() por require() (quebra) — usa <script type=module>
    carregando = new Promise(function (ok, erro) {
      window.__vkPswpOk = ok; window.__vkPswpErro = erro;
      var sc = document.createElement('script');
      sc.type = 'module';
      sc.textContent = 'import P from ' + JSON.stringify(window.photoswipeUrls.coreJs) + '; window.__vkPswpOk(P);';
      sc.onerror = function () { erro(new Error('PhotoSwipe não carregou')); };
      document.head.appendChild(sc);
      setTimeout(function () { erro(new Error('PhotoSwipe demorou')); }, 8000);
    });
    return carregando;
  }

  var cacheMedidas = null;
  function nomeArquivo(u) { return String(u || '').split('?')[0].split('/').pop(); }
  function medidas() {
    if (cacheMedidas) return cacheMedidas;
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    cacheMedidas = !m ? Promise.resolve({}) : fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var mapa = {};
      (p.media || []).forEach(function (x) { if (x.src) mapa[nomeArquivo(x.src)] = { w: x.width, h: x.height }; });
      return mapa;
    }).catch(function () { return {}; });
    return cacheMedidas;
  }
  function urlGrande(img) {
    var src = img.currentSrc || img.src || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/([?&])width=\d+/, '$1width=2048').replace(/&?height=\d+/, '');
  }

  function fotosVisiveis() {
    var itens = Array.prototype.slice.call(document.querySelectorAll('[data-zoom-index]'));
    return itens.filter(function (el) {
      if (el.closest('dialog') || el.closest('zoom-dialog dialog')) return false;
      if (!el.offsetParent) return false;
      return !!el.querySelector('img') && !el.querySelector('video, iframe, model-viewer');
    });
  }

  function abrir(indiceTema, original, ctx, args) {
    var fotos = fotosVisiveis();
    var alvo = null;
    for (var i = 0; i < fotos.length; i++) if (String(fotos[i].dataset.zoomIndex) === String(indiceTema)) { alvo = fotos[i]; break; }
    if (!alvo) { if (window.console) console.warn('[vk-zoom] foto não achada', indiceTema, fotos.length); return original.apply(ctx, args); } // vídeo/3D: zoom do tema
    var indice = fotos.indexOf(alvo);
    // tamanho REAL de cada foto vem do cadastro (/products/<handle>.js): os atributos width/height do <img> do tema
    // não são confiáveis (no computador dizem 3840 px). Catálogo ~800–1024 px → o zoom vai só até o nítido.
    var tamanhos = medidas();
    return Promise.all([carregar(), tamanhos]).then(function (r) {
      var PhotoSwipe = r[0], tam = r[1];
      var dados = fotos.map(function (el) {
        var img = el.querySelector('img');
        var t = tam[nomeArquivo(img.currentSrc || img.src)] || {};
        var w = t.w || img.naturalWidth || 1000, h = t.h || img.naturalHeight || 1500;
        if (w > 2048) { h = Math.round(h * 2048 / w); w = 2048; }
        return { src: urlGrande(img), msrc: img.currentSrc || img.src, width: w, height: h, alt: img.alt || '' };
      });
      var pswp = new PhotoSwipe({
        dataSource: dados,
        index: indice,
        bgOpacity: 1,
        showHideAnimationType: 'fade',
        initialZoomLevel: 'fit',
        // zoom relativo ao tamanho real: toque/duplo toque = 100% da foto (≈2–2,5x na tela do celular), pinça até 160%
        secondaryZoomLevel: function (zl) { return Math.max(1, zl.fit * 2); },
        maxZoomLevel: function (zl) { return Math.max(1.6, zl.fit * 3); },
        imageClickAction: 'zoom',
        tapAction: 'zoom',
        doubleTapAction: 'zoom',
        wheelToZoom: true,
        padding: { top: 48, bottom: 24, left: 0, right: 0 },
        closeTitle: 'Fechar', zoomTitle: 'Ampliar', arrowPrevTitle: 'Foto anterior', arrowNextTitle: 'Próxima foto',
        errorMsg: 'Não foi possível carregar a foto',
        indexIndicatorSep: ' / '
      });
      pswp.on('close', function () { var d = document.querySelector('.vk-zoom-dica'); if (d) d.remove(); });
      pswp.init();
      if (!dicaVista) {
        dicaVista = true;
        try { localStorage.setItem('vk_zoom_dica', '1'); } catch (er) {}
        var dica = document.createElement('div');
        dica.className = 'vk-zoom-dica';
        dica.textContent = matchMedia('(hover: none)').matches ? 'Toque na foto ou use dois dedos para ampliar' : 'Clique na foto para ampliar';
        document.body.appendChild(dica);
        setTimeout(function () { dica.style.opacity = '0'; }, 2600);
        setTimeout(function () { dica.remove(); }, 3200);
      }
    }).catch(function (er) { if (window.console) console.warn('[vk-zoom] usando o zoom do tema:', er); return original.apply(ctx, args); });
  }

  // troca o "abrir" do zoom do tema (vale para clique, toque no carrossel e qualquer outro caminho)
  customElements.whenDefined('zoom-dialog').then(function () {
    var C = customElements.get('zoom-dialog');
    if (!C || C.prototype.__vk) return;
    var original = C.prototype.open;
    C.prototype.__vk = true;
    C.prototype.open = function (index, event) {
      if (event && event.preventDefault) event.preventDefault();
      return abrir(index, original, this, arguments);
    };
  });
})();
